// @flow

// Constants
import {
  // Model Properties
  RECOMMENDATION_FERTILIZER_SET,
  PROP_ELEMENT_PICK,
  PROP_ELEMENT_SPLIT,
  PROP_PERCENT_SPLIT,
  ELEMENT_SPLIT_TYPE,
} from '../constants'

import _forEach from 'lodash/forEach'
import _isEmpty from 'lodash/isEmpty'
import _size from 'lodash/size'
import _filter from 'lodash/filter'
import _reduce from 'lodash/reduce'

// Export
export default function validateModel (model: Object): Array<{ [string]: string }> {
  const errors = []

  if (_size(model[ELEMENT_SPLIT_TYPE] || {}) > 0) {
    _forEach(model[ELEMENT_SPLIT_TYPE], (type: string, element: string) => {
      const splitPrescriptions = _filter(model[RECOMMENDATION_FERTILIZER_SET], [PROP_ELEMENT_PICK, element])
      if (type === PROP_PERCENT_SPLIT) {
        let zeroPercentValues = 0
        _forEach(splitPrescriptions, (prescription: Object) => {
          if (
            !_isEmpty(prescription[PROP_PERCENT_SPLIT]) &&
            Number(prescription[PROP_PERCENT_SPLIT]) <= 0
          ) {
            zeroPercentValues++
          }
        })
        if (zeroPercentValues > 0) {
          errors.push({
            [RECOMMENDATION_FERTILIZER_SET]: {
              key: 'percentSplitValueMustBeLargerThanZero',
              values: {
                element,
              },
            },
          })
        }

        const percentTotal = _reduce(splitPrescriptions, (acc: number, prescription: Object): number => {
          const percent = prescription[PROP_PERCENT_SPLIT] ? Number(prescription[PROP_PERCENT_SPLIT]) : 0
          return acc + percent
        }, 0)
        if (percentTotal !== 100) {
          errors.push({
            [RECOMMENDATION_FERTILIZER_SET]: {
              key: 'totalForPercentSplitShouldEqual100',
              values: {
                element,
              },
            },
          })
        }
      } else if (type === PROP_ELEMENT_SPLIT) {
        let zeroElementValues = 0
        _forEach(splitPrescriptions, (prescription: Object) => {
          if (
            !_isEmpty(prescription[PROP_ELEMENT_SPLIT]) &&
            Number(prescription[PROP_ELEMENT_SPLIT]) <= 0
          ) {
            zeroElementValues++
          }
        })
        if (zeroElementValues > 0) {
          errors.push({
            [RECOMMENDATION_FERTILIZER_SET]: {
              key: 'elementSplitValueMustBeLargerThanZero',
              values: {
                element,
              },
            },
          })
        }

        const elementSplitRates = _filter(splitPrescriptions, (prescription: Object): boolean => {
          return (
            prescription[PROP_ELEMENT_SPLIT] ||
            (Number(prescription[PROP_ELEMENT_SPLIT]) === 0 && prescription[PROP_ELEMENT_SPLIT])
          )
        })
        if (elementSplitRates.length !== splitPrescriptions.length - 1) {
          errors.push({
            [RECOMMENDATION_FERTILIZER_SET]: {
              key: 'splitElementsShouldHaveOnlyOneBlankRate',
              values: {
                element,
              },
            },
          })
        }
      }
    })
  }

  return errors
}
